import { useEffect } from 'react'

/**
 * Prevent the reload of the page if a block flag is true;
 * shows message to user first.
 * - reload modal cannot be customized (security reasons) from Browser.
 * @param {*} args
 * @param {boolean} args.block Should the reload be blocked.
 */
export const useEffectPreventReload = ({ block = false }) => {
  useEffect(() => {
    const beforeUnload = e => {
      if (!block) return false

      e.preventDefault()
      e.returnValue = true
    }

    window.addEventListener('beforeunload', beforeUnload)

    return () => {
      window.removeEventListener('beforeunload', beforeUnload)
    }
  }, [block])
}
